/**
 * MICRO-ANIMATIONS 
 * Handles global scroll-based reveal animations
 */

class RevealManager {
  constructor() {
    this.init();
  }

  init() {
    // We only observe elements that have the semantic `reveal-on-scroll` class.
    // By requirement, all H2 headers should have this effect, but we apply the class to them in the liquid files.
    const revealElements = document.querySelectorAll('.reveal-on-scroll');
    
    if (!revealElements.length) return;

    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -10% 0px', // Trigger slightly before the element comes entirely into view
      threshold: 0.1
    };

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          // unobserve after revealing if we only want it to happen once
          observer.unobserve(entry.target); 
        }
      });
    }, observerOptions);

    revealElements.forEach(el => observer.observe(el));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new RevealManager();
});
